import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';
import { DOC_SECTIONS } from '../../utils/constants';

function Sidebar() {
    const [isOpen, setIsOpen] = useState(false);
    const contents = DOC_SECTIONS;
    // Lock body scroll when drawer is open on mobile
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    // Close drawer on Escape
    useEffect(() => {
        const onKey = (e) => {
            if (e.key === 'Escape') setIsOpen(false);
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, []);

    const listMarkup = (
        <ul className="sb-list">
            {contents.map(({ title, children }, index) => (
                <React.Fragment key={index}>
                    {title && <h5 className="sb-section-title">{title}</h5>}
                    {children.map(({ text, link, exact }, index2) => (
                        <li key={`${index}-${index2}`} className="sb-item">
                            <NavLink
                                to={link}
                                exact={exact}
                                activeClassName="sb-link-active"
                                className="sb-link"
                                onClick={() => setIsOpen(false)}
                            >
                                {text}
                            </NavLink>
                        </li>
                    ))}
                </React.Fragment>
            ))}
        </ul>
    );

    return (
        <>
            {/* DESKTOP: original sticky sidebar */}
            <div className="documentation-sidebar sb-desktop overflow-y-scroll bg-light-theme">
                {listMarkup}
            </div>

            {/* MOBILE: floating toggle button (bottom-left, mirrors RightNav) */}
            <button
                type="button"
                className="sb-toggle"
                aria-label="Open navigation menu"
                aria-expanded={isOpen}
                onClick={() => setIsOpen(true)}
            >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="3" y1="6" x2="21" y2="6" />
                    <line x1="3" y1="12" x2="21" y2="12" />
                    <line x1="3" y1="18" x2="21" y2="18" />
                </svg>
                <span>Menu</span>
            </button>

            {/* MOBILE: backdrop */}
            <div
                className={`sb-backdrop ${isOpen ? 'sb-backdrop-open' : ''}`}
                onClick={() => setIsOpen(false)}
                aria-hidden="true"
            />

            {/* MOBILE: slide-in drawer from left */}
            <aside
                className={`sb-drawer ${isOpen ? 'sb-drawer-open' : ''}`}
                role="dialog"
                aria-modal="true"
                aria-label="Navigation menu"
            >
                <div className="sb-drawer-header">
                    <span className="sb-drawer-title">Documentation</span>
                    <button
                        type="button"
                        className="sb-close"
                        aria-label="Close navigation menu"
                        onClick={() => setIsOpen(false)}
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                    </button>
                </div>
                <div className="sb-drawer-body">{listMarkup}</div>
            </aside>
        </>
    );
}

export default Sidebar;
